import { createControlComponent } from '@react-leaflet/core'
import L from 'leaflet'

interface TooltipControlProps {
    onToggle: (show: boolean) => void
}

// Создаем кастомный контрол для Leaflet
class TooltipControlClass extends L.Control {
    private isActive = false
    private onToggle: (show: boolean) => void

    constructor(options: L.ControlOptions & { onToggle: (show: boolean) => void }) {
        super(options)
        this.onToggle = options.onToggle
    }

    onAdd(): HTMLElement {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control')
        const button = L.DomUtil.create('a', 'leaflet-control-tooltip', container)
        
        button.href = '#'
        button.title = 'Показать/скрыть подсказки'
        button.innerHTML = '💬'
        button.style.width = '30px'
        button.style.height = '30px'
        button.style.display = 'flex'
        button.style.alignItems = 'center'
        button.style.justifyContent = 'center'
        button.style.fontSize = '16px'
        button.style.textDecoration = 'none'
        button.style.color = '#333'
        button.style.backgroundColor = 'white'
        
        // Обработчик клика
        L.DomEvent.on(button, 'click', (e: Event) => {
            L.DomEvent.preventDefault(e)
            L.DomEvent.stopPropagation(e)
            
            this.isActive = !this.isActive
            button.style.backgroundColor = this.isActive ? '#007cff' : 'white'
            button.style.color = this.isActive ? 'white' : '#333'
            button.title = this.isActive ? 'Скрыть подсказки' : 'Показать подсказки'
            
            this.onToggle(this.isActive)
        })
        
        // Предотвращаем пропагацию событий карты
        L.DomEvent.disableClickPropagation(container)
        L.DomEvent.disableScrollPropagation(container)
        
        return container
    }
}

// React-компонент для контрола
const TooltipControl = createControlComponent<TooltipControlClass, TooltipControlProps & L.ControlOptions>((props) => {
    return new TooltipControlClass({
        position: 'topleft',
        onToggle: props.onToggle
    })
})

export default TooltipControl
